export * from '../../app/services/api/menus/menusTypes';

export enum MenuDetailTab {
  Overview = 'overview',
  ServicePeriods = 'servicePeriods',
  MenuStructure = 'menuStructure',
  StandaloneItems = 'standaloneItems',
  Sites = 'sites',
  Costing = 'costing',
  AllergensAndDietary = 'allergensAndDietary',
  CarbonAndSustainability = 'carbonAndSustainability',
  VersionHistory = 'versionHistory',
  Publishing = 'publishing',
}
